import React, { useState, useEffect } from 'react';
import { Eye, EyeOff, Lock, User, Loader2 } from 'lucide-react';

export default function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [secureMode, setSecureMode] = useState(true);
  const base_url = 'https://onboard.fck.ind.br';
  //const base_url = process.env.REACT_APP_API_URL || 'http://localhost:5000';   

  useEffect(() => {
    const savedUser = localStorage.getItem('@last_user');
    if (savedUser) setUsername(savedUser);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      alert('Preencha todos os campos.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${base_url}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      const data = await response.json();

      if (response.ok) {
        // Armazena o token e o usuário para persistência
        localStorage.setItem('@user_token', data.token);
        localStorage.setItem('@last_user', username);
        localStorage.setItem('@mostra_producao', data.mostraProducao);
        localStorage.setItem('@mostraRecebiveis', data.mostraRecebiveis);
        localStorage.setItem('@mostraFaturamento', data.mostraFaturamento);
        localStorage.setItem('@mostraExpedicao', data.mostraExpedicao);
        localStorage.setItem('@NomeUsuario', data.nomeUsuario);
        console.log(data.nomeUsuario);

        onLoginSuccess();
      } else {
        alert(data.error || 'Usuário ou senha inválidos.');
      }
    } catch (error) {
      console.error("Erro no login:", error);
      alert('Falha na conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0d1117] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#161b22] border border-gray-800 rounded-xl p-8 shadow-2xl">
        <div className="flex flex-col items-center mb-8">
          <img
            //src="https://suprasoft.net/imagens/logo-erp-supramais.png" 
            src="https://fck.ind.br/wp-content/uploads/2025/05/logo-fck-premoldados.webp"
           //src="https://helpdesk.suprasoft.net/imagens/logo.png"
            alt="Logo"
            className="w-28 h-auto mb-2 opacity-50"
          />
          <h2 className="text-white text-[10px] tracking-[0.5em] uppercase font-black opacity-80">
            Acesso Restrito
          </h2>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-[10px] uppercase font-bold text-gray-500 mb-1 ml-1">Usuário</label>
            <div className="relative">
              <User className="absolute left-3 top-3.5 text-gray-600" size={18} />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full bg-[#0d1117] border border-gray-800 rounded-lg py-3 pl-10 pr-4 text-white focus:outline-none focus:border-blue-500 transition-colors"
                placeholder="Digite seu usuário"
              />
            </div>
          </div>

          <div>
            <label className="block text-[10px] uppercase font-bold text-gray-500 mb-1 ml-1">Senha</label>
            <div className="relative">
              <Lock className="absolute left-3 top-3.5 text-gray-600" size={18} />
              <input
                type={secureMode ? "password" : "text"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#0d1117] border border-gray-800 rounded-lg py-3 pl-10 pr-12 text-white focus:outline-none focus:border-blue-500 transition-colors"
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => setSecureMode(!secureMode)}
                className="absolute right-3 top-3.5 text-gray-600 hover:text-gray-400"
              >
                {secureMode ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-lg transition-all flex items-center justify-center gap-2 mt-4 disabled:opacity-50"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : "ENTRAR NO SISTEMA"}
          </button>
        </form>
      </div>
    </div>
  );
}